var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "pa-1 animate__animated animate__fadeIn",
              attrs: { cols: "12", xs: "12", sm: "6" },
            },
            [
              _c(
                "v-card",
                { staticClass: "soli-round" },
                [
                  _c(
                    "v-container",
                    [
                      _c("v-card-title", { staticClass: "soli-grey" }, [
                        _vm._v("My Agenda"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          class: ["ma-6 "],
                          staticStyle: {
                            position: "absolute",
                            top: "0px",
                            right: "0px",
                          },
                          attrs: { plain: "", ripple: false },
                          on: {
                            click: function ($event) {
                              _vm.today = !_vm.today
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                color: _vm.today ? "primary" : "secondary",
                              },
                            },
                            [_vm._v("list")]
                          ),
                          _c("small", { staticClass: "ml-2" }, [
                            _vm._v(_vm._s(_vm.today ? "Today" : "This Week")),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-container",
                        [
                          _vm.is("Teacher")
                            ? _c("LessonAgenda", {
                                attrs: {
                                  events: _vm.getLessons,
                                  assignments: [],
                                },
                                on: {
                                  success: function ($event) {
                                    return _vm.$emit("success")
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !!_vm.teachingHours.length
            ? _c(
                "v-col",
                {
                  staticClass: "pa-1 animate__animated animate__fadeIn",
                  attrs: { cols: "12", xs: "12", sm: "6" },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "soli-round" },
                    [
                      _c(
                        "v-container",
                        [
                          _c("v-card-title", { staticClass: "soli-grey" }, [
                            _vm._v("Teaching Hours"),
                          ]),
                          _vm._v(" "),
                          _c("v-card-subtitle", { staticClass: "soli-grey" }, [
                            _vm._v("Total: " + _vm._s(_vm.teachingHours[2])),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-container",
                            [
                              _c("trend", {
                                attrs: {
                                  data: _vm.teachingHours,
                                  gradient: ["#6fa8dc", "#42b983", "#2c3e50"],
                                  "auto-draw": "",
                                  smooth: "",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                { staticClass: "justify-between pa-3" },
                                [
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.globalMomentDate(
                                          _vm.$page.props.auth.user.created_at
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.globalMomentDate(
                                          new Date(
                                            (new Date(
                                              _vm.$page.props.auth.user.created_at
                                            ).getTime() +
                                              new Date().getTime()) /
                                              2
                                          )
                                        )
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(_vm.globalMomentDate(new Date()))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }